import { money0 } from "../../api";
import { plural } from "./HomeBits";

// One sentence about today. Amber only when something actually needs the user.
export function todayParts(t, workspace) {
  const p = [];
  if (t.attention) p.push(`${plural(t.attention, "item")} need${t.attention === 1 ? "s" : ""} attention`);
  if (t.jobs_starting) p.push(`${plural(t.jobs_starting, "job")} ${workspace === "estimating" ? "on site" : "starting"}`);
  if (t.appointments) p.push(plural(t.appointments, "appointment"));
  if (t.approvals) p.push(`${plural(t.approvals, "approval")} required`);
  if (t.overdue_value) p.push(`${money0(t.overdue_value)} overdue`);
  if (t.delayed_deliveries) p.push(`${plural(t.delayed_deliveries, "delivery", "deliveries")} delayed`);
  if (workspace !== "estimating" && t.unassigned) p.push(`${plural(t.unassigned, "job")} unassigned`);
  if (workspace !== "estimating" && t.conflicts) p.push(plural(t.conflicts, "schedule clash", "schedule clashes"));
  return p;
}

export function TodayStrip({ today, workspace, onView }) {
  const parts = todayParts(today, workspace);
  const warn = today.attention > 0 || today.overdue_value > 0 || today.delayed_deliveries > 0;
  return (
    <div className={`today-strip ${warn ? "warn" : ""}`} data-testid="today-snapshot" data-warn={warn ? "1" : "0"}>
      <span className="today-dot" aria-hidden />
      <p className="min-w-0 flex-1 text-[13.5px] leading-snug">
        <span className="t1 font-semibold">Today</span>
        <span className="t2" data-testid="today-summary">{parts.length ? ` · ${parts.join(" · ")}` : " · All clear — nothing needs you right now."}</span>
      </p>
      <button type="button" className="btn-secondary btn-sm shrink-0" onClick={onView} data-testid="view-today-btn">View today</button>
    </div>
  );
}
